import React, { useEffect, useState } from "react";
import { IoMenu } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import Navbar from "./Navbar";


const Header = ({ isAuthenticated, setRatingIsOpen}) => {
  const [isNotificationOpen, setNotificationOpen] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const location = useLocation();
  
  const handleOutsideClick = (event) => {
    const menuElement = document.getElementById("navbar");
    const menuIcon = document.getElementById("menu-icon");
    if (
      menuElement &&
      !menuElement.contains(event.target) &&
      menuIcon &&
      !menuIcon.contains(event.target)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isOpen]);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <header className="shadow-md h-[80px] flex items-center fixed top-0 left-0 right-0 w-full z-[200] bg-whiteBg ">
      <div className="relative container flex justify-between items-center ">
        <Link to="/">
          <img src="/logo.svg" alt="" />
        </Link>
        <div id="navbar">
        <Navbar isAuthenticated={isAuthenticated}  isOpen={isOpen} setNotificationOpen={setNotificationOpen} isNotificationOpen={isNotificationOpen} setRatingIsOpen={setRatingIsOpen} />
        </div>
      </div>
      <div>
          <IoMenu
          id="menu-icon"
            className="text-4xl custom:hidden mr-7"
            onClick={() => setOpen(!isOpen)}
          />
        </div>
    </header>
  );
};

export default Header;
